import React, { useState, useEffect } from 'react'
import { colors } from 'utils/utils'
import { injectIntl } from 'gatsby-plugin-intl'
import { IoIosArrowBack } from 'react-icons/io'
import AccordionMenu from './AccordionMenu'
import styled from 'styled-components'

export default injectIntl(props => {
	const {data, category, tableHeaders, backButton} = props
	const [groupData, setGroupData] = useState({})

	useEffect(() => {
		const groupDataTemp = data.sort((a,b) => {
			const avalue = a.provider
			const bvalue = b.provider
			if (avalue < bvalue) return -1
			if (avalue > bvalue) return 1
			return 0
		}).reduce((hash, obj) => {
			if(obj["provider"] === undefined) return hash
			return Object.assign(hash, { [obj["provider"]]:( hash[obj["provider"]] || [] ).concat(obj)})
		}, {})
		setGroupData({...groupDataTemp})
	}, [data])
	return(
		<>
			<BackButton onClick={props.closeViewDetails}>
				<IoIosArrowBack />
				<span>{backButton}</span>
			</BackButton>
			<Title>{category}</Title>
			<Table>
			{
				groupData && Object.keys(groupData).length > 0 && Object.keys(groupData).map((provider, catIndex) =>
					<AccordionMenu 
						key={`catCookie${catIndex}`}
						title={provider}
					>
						{
							Object.values(groupData)[catIndex].map((cookie, cookieIndex) => 
								<Cookie key={`cookie${cookieIndex}`}>
									<Field>
										<TableHeader>{tableHeaders.name}:</TableHeader>
										<TableDataCell>{cookie.name}</TableDataCell>						
									</Field>
									<Field>
										<TableHeader>{tableHeaders.provider}:</TableHeader>
										<TableDataCell>{cookie.provider}</TableDataCell>						
									</Field>
									<Field>
										<TableHeader>{tableHeaders.expiration}:</TableHeader>
										<TableDataCell>{cookie.expiration}</TableDataCell>						
									</Field>
									<Field>
										<TableHeader>{tableHeaders.type}:</TableHeader>
										<TableDataCell>{cookie.type}</TableDataCell>						
									</Field>
									<Field>
										<TableHeader>{tableHeaders.purpose}:</TableHeader>
										<TableDataCell>{cookie.purpose}</TableDataCell>						
									</Field>
								</Cookie>							
							)
						}
					</AccordionMenu>
				)
			}
			</Table>
		</>
	)
})

const BackButton = styled.button`
	display: flex;
	flex-direction: row;
	border: 0;
	background-color: transparent;
	padding: 1rem 1.5rem;
	font-size: 1rem;
	font-weight: 700;
	cursor: pointer;
	transform: translateX(-2rem);
	svg {
		margin-right: .5rem;
		self-align: center;
	}
`

const Title = styled.h3`
`

const Cookie = styled.div`
	padding: 1rem 1.5rem;
	margin: .5rem 0;
	background-color: ${colors.quinary};
	&:first-of-type {
		margin-top: 0;
	}
	&:last-of-type {
		margin-bottom: 0;
	}
`

const Field = styled.div`
	display: flex;
	flex-direction: row;
	padding: .5rem 0;
	font-size: .75rem;
	&:not(:last-of-type) {
		border-bottom: solid .1rem ${colors.tertiary};
	}
`

const Table = styled.div`
`

const TableHeader = styled.span`
	min-width: 6.25rem;
	font-weight: 700;
	margin-right: 1rem;
`

const TableDataCell = styled.span`
`